import React from 'react';
import CtaButton from '../CallToAction/ctaButton';
// import thumbs from '../../../assets/thumbs.svg';
import { ReactComponent as ThumbsSVG1 } from '../../../assets/thumbs1.svg';
import { ReactComponent as ThumbsSVG2 } from '../../../assets/thumbs2.svg';
import './styles/Hero.css';
import '../../styles/landing_page.css';

function Hero() {
	return (
		<div className="hero__container">
			{/* Hero Content */}
			{/* <div className="hero__content"> */}
			{/* Hero Image 1 */}
			{/* <div className="hero__image1"> */}
			<ThumbsSVG1 />
			{/* </div> */}
			<div className="hero__content">
				{/* Hero Text */}
				<div className="hero__heading">
					<h1>THUMBS</h1>
					<p>A fast and easy way to rate and review your favorite products</p>
				</div>

				{/* Hero Call To Action Button */}
				<div className="hero__button">
					<CtaButton />
				</div>
			</div>

			{/* Hero Image2 */}
			{/* <div className="hero__image2"> */}
			<ThumbsSVG2 />
			{/* </div> */}
		</div>
	);
}

export default Hero;

// function Hero() {
// 	return (
// 		<div className="hero__container">
// 			<div className="hero__upper_thumbs">
// 				<ThumbsSVG />
// 			</div>
// 			<div className="hero__content">
// 				{/* Hero Text */}
// 				<h1>THUMBS</h1>
// 				{/* Hero Call To Action Button */}
// 				<div className="hero__button">
// 					<CtaButton />
// 				</div>
// 				{/* Hero Image */}
// 				{/* <div className="hero__image"> */}

// 				{/* </div> */}
// 			</div>
// 			<ThumbsSVG />
// 		</div>
// 	);
// }

// export default Hero;
